import { render, staticRenderFns } from "./AddTariffPage.vue?vue&type=template&id=d0de4506&scoped=true&"
import script from "./AddTariffPage.vue?vue&type=script&lang=js&"
export * from "./AddTariffPage.vue?vue&type=script&lang=js&"
import style0 from "./AddTariffPage.vue?vue&type=style&index=0&id=d0de4506&prod&lang=scss&scoped=true&"
import style1 from "./AddTariffPage.vue?vue&type=style&index=1&id=d0de4506&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0de4506",
  null
  
)

export default component.exports